import React from "react";
import {
  CardContent,
  Button,
  Fade,
  Tooltip,
  Box,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  ModernCard,
  ProductImage,
} from "../FramelessSelect/FramelessSelect.styled";

const UnitTypeCard = ({
  id,
  title,
  description,
  buttonText,
  image,
  alt,
  disabled = false,
  comingSoon,
  onSelect,
  index = 0,
}) => {
  const theme = useTheme();

  const handleClick = () => {
    if (!disabled && onSelect) {
      onSelect(id);
    }
  };

  return (
    <Fade in timeout={1600 + index * 200}>
      <Tooltip title={disabled ? comingSoon : ""} arrow placement="top">
        <Box>
          <ModernCard
            onClick={disabled ? undefined : handleClick}
            sx={{
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.6 : 1,
              position: "relative",
              "&:hover": disabled
                ? {}
                : {
                    transform: "translateY(-8px) scale(1.02)",
                    boxShadow: "0 32px 64px rgba(0, 0, 0, 0.15)",
                    "& .product-image": {
                      transform: "scale(1.1)",
                    },
                  },
            }}
          >
            {disabled && (
              <Box
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  zIndex: 10,
                  backgroundColor: theme.palette.warning?.main || "#ff9800",
                  color: "white",
                  px: 2,
                  py: 0.5,
                  borderRadius: "12px",
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                }}
              >
                {comingSoon}
              </Box>
            )}
            <ProductImage>
              {image && (
                <img
                  src={image}
                  alt={alt}
                  className="product-image"
                  style={{
                    filter: disabled ? "grayscale(50%)" : "none",
                  }}
                />
              )}
            </ProductImage>
            <CardContent
              sx={{
                p: 4,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="h5"
                  component="h3"
                  sx={{
                    fontWeight: 800,
                    mb: 2,
                    color: theme.palette.dark?.main || "text.primary",
                    textAlign: "center",
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "text.secondary",
                    textAlign: "center",
                    lineHeight: 1.6,
                    mb: 3,
                  }}
                >
                  {description}
                </Typography>
              </Box>
              <Button
                variant="contained"
                size="large"
                fullWidth
                disabled={disabled}
                sx={{
                  borderRadius: "12px",
                  py: 1.5,
                  background: disabled
                    ? "rgba(0, 0, 0, 0.12)"
                    : `linear-gradient(135deg, ${theme.palette.primary.other}, ${theme.palette.secondary.main})`,
                  boxShadow: disabled
                    ? "none"
                    : "0 8px 24px rgba(0, 0, 0, 0.15)",
                  "&:hover": disabled
                    ? {}
                    : {
                        boxShadow: "0 12px 32px rgba(0, 0, 0, 0.2)",
                        transform: "translateY(-2px)",
                      },
                  transition: "all 0.3s ease",
                }}
              >
                {buttonText}
              </Button>
            </CardContent>
          </ModernCard>
        </Box>
      </Tooltip>
    </Fade>
  );
};

export default UnitTypeCard;
